import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DataService } from '../../common/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTokenHandler } from '../../common/app-token-handler';
import { saveAs } from 'file-saver';
import { CommonService } from 'src/app/services/common.service';
@Component({
    selector: 'app-search-resume',
    templateUrl: './search-resume.component.html',
    styleUrls: ['./search-resume.component.css']
})
export class SearchResumeComponent implements OnInit {
    constructor(private gservice: DataService, private router: Router,
        private appToken: AppTokenHandler, private cp: DatePipe, private _commonService: CommonService) { }
    IsFilterTabSelected: boolean = true;
    PageHeading: string = "Search Resume";
    first: number = 0;
    loading: boolean = false;
    SMUList: Array<any> = [];
    SelectedSMUList: Array<any> = [];
    EngTypeList: Array<any> = [];
    SelectedEngTypeList: Array<any> = [];
    EngSubTypeList: Array<any> = [];
    SelectedEngSubTypeList: Array<any> = [];
    MarketSegmentList: Array<any> = [];
    SelectedMarketSegmentList: Array<any> = [];
    EngSectorList: Array<any> = [];
    SelectedEngSectorList: Array<any> = [];
    EngSubSectorList: Array<any> = [];
    SelectedEngSubSectorList: Array<any> = [];
    GeographicTypeList: Array<any> = [];
    SelectedGeographicTypeList: Array<any> = [];
    DesignationsList: Array<any> = [];
    SelectedDesignationsList: Array<any> = [];
    RequestDetailsList: Array<any> = [];
    SelectedRequestDetailsList: Array<any> = [];
    SearchText: string = '';
    YearOfExperience: Array<any> = [];
    SelectedYearOfExperience: Array<any> = [];
    cols: any[];
    ResumePerPageSelected: number = 1;
    ngOnInit() {
        this.YearOfExperience = [
            { Value: '0-5', Text: '0 to 5 Years' },
            { Value: '5-10', Text: '5 to 10 Years' },
            { Value: '10-15', Text: '10 to 15 Years' },
            { Value: '15-20', Text: '15 to 20 Years' },
            { Value: '20-60', Text: '20 Years and Above' }]
        this.cols = [
            { field: 'ResumeId', header: 'Resume ID' },
            { field: 'EmployeeName', header: 'Employee Name' },
            { field: 'EmpTitle', header: 'Designation' },
            { field: 'YearOfExperience', header: 'Years of Experience' },
            { field: 'SMU', header: 'Competency' },
            { field: 'EngTitle', header: 'Eng Type' },
            { field: 'Sector', header: 'Eng Sector' },
            { field: 'SubSector', header: 'Eng Sub Sector' },
            { field: 'GeographicType', header: 'Geographic Type' },
            { field: 'RelevantMandates', header: 'Relevant Mandates' }
        ];

        var objSearch = { loginEmpGPN: '', EngSMU: '', EngType: '', EngSubType: '', EngSector: '', MarketSegment: '', Designation: '', YearOfExp: '', TextSearch: this.SearchText };
        this.GetFilterValues(-1, objSearch);
    }
    GetFilterValues(filterType: number, serchObj: any = null) {
        this.gservice.PostData("GetResumeSearchFilters", serchObj).subscribe((data: any) => {
            if (filterType === -1) {
                this.SMUList = data.Table;
                this.SelectedSMUList = [];
            }
            if (filterType === -1 || filterType === 0) {
                this.EngTypeList = data.Table1;
                this.SelectedEngTypeList = [];
            }
            if (filterType === -1 || filterType === 0 || filterType === 1) {
                this.EngSubTypeList = data.Table2;
                this.SelectedEngSubTypeList = [];
            }
            if (filterType === -1 || filterType === 0 || filterType === 1 || filterType === 2) {
                this.MarketSegmentList = data.Table3;
                this.SelectedMarketSegmentList = [];
            }
            if (filterType === -1 || filterType === 0 || filterType === 1) {
                this.EngSectorList = data.Table4;
                this.SelectedEngSectorList = [];
            }
            if (filterType === -1 || filterType === 0 || filterType === 1 || filterType == 4) {
                this.EngSubSectorList = data.Table5;
                this.SelectedEngSubSectorList = [];
            }
            if (filterType === -1 || filterType === 0 || filterType === 1 || filterType == 2 || filterType == 3) {
                this.GeographicTypeList = data.Table6;
                this.SelectedGeographicTypeList = [];
            }
            this.DesignationsList = data.Table7;
            this.BindDataFromCache();
        });
    }
    OnOpenCloseAccordingControl(status: boolean) {
        this.IsFilterTabSelected = status;
    }
    OnFilterSelection(filterType: number) {
        var objSearch = { loginEmpGPN: '', EngSMU: '', EngType: '', EngSubType: '', EngSector: '', MarketSegment: '', Designation: '', YearOfExp: '', TextSearch: this.SearchText };
        if (this.SelectedSMUList.length > 0) {
            objSearch.EngSMU = this.SelectedSMUList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedEngTypeList.length > 0) {
            objSearch.EngType = this.SelectedEngTypeList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedEngSubTypeList.length > 0) {
            objSearch.EngSubType = this.SelectedEngSubTypeList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedMarketSegmentList.length > 0) {
            objSearch.MarketSegment = this.SelectedMarketSegmentList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedEngSectorList.length > 0) {
            objSearch.EngSector = this.SelectedEngSectorList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedDesignationsList.length > 0) {
            objSearch.Designation = this.SelectedDesignationsList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedYearOfExperience.length > 0) {
            objSearch.YearOfExp = this.SelectedYearOfExperience.map((item) => { return item.Value }).join(',');
        }
        this.GetFilterValues(filterType, objSearch);
    }
    paginate(event) {
        this.first = event.first;
    }
    GetResult() {
        this.first = 0;
        this.loading = true;
        this.RequestDetailsList = [];
        this.SelectedRequestDetailsList = [];
        let objSearch: any = this.GetSearchObject();
        this.gservice.PostData("SearchResumeForPPTCreation", objSearch).subscribe((data: any) => {
            console.log(data.Table);
            this.RequestDetailsList = data.Table;
            //this.IsFilterTabSelected = true;
            this.StoreDataInCache();
            this.loading = false;
        });
    };
    RefreshSearchResult() {
        //this.IsFilterTabSelected = true;
        this.first = 0;
        this.SMUList = [];
        this.SelectedSMUList = [];
        this.EngTypeList = [];
        this.SelectedEngTypeList = [];
        this.EngSubTypeList = [];
        this.SelectedEngSubTypeList = [];
        this.MarketSegmentList = [];
        this.SelectedMarketSegmentList = [];
        this.EngSectorList = [];
        this.SelectedEngSectorList = [];
        this.EngSubSectorList = [];
        this.SelectedEngSubSectorList = [];
        this.GeographicTypeList = [];
        this.SelectedGeographicTypeList = [];
        this.DesignationsList = [];
        this.SelectedDesignationsList = [];
        this.RequestDetailsList = [];
        this.SelectedRequestDetailsList = [];
        this.SearchText = '';
        this.SelectedYearOfExperience = [];
        var objSearch = { loginEmpGPN: '', EngSMU: '', EngType: '', EngSubType: '', EngSector: '', MarketSegment: '', Designation: '', YearOfExp: '', TextSearch: this.SearchText };
        this.GetFilterValues(-1, objSearch);
    };
    onCickRequestNumber(RequestNumber) {
        this.StoreDataInCache();
        this.router.navigate(['/home/resume'], { queryParams: { param1: this._commonService.EncryptData(RequestNumber) } });
    };
    AddToCart() {
        let objSearch: any = this.GetSearchObject();
        let cartItems: any = [];
        if (sessionStorage.getItem('ResumeCart') != null) {
            cartItems = JSON.parse(sessionStorage.getItem('ResumeCart'));
        }
        if (cartItems.length <= 0) {
            let objSelectedItems: Array<any> = [];
            for (let i = 0; i < this.SelectedRequestDetailsList.length; i++) {
                let _resumeObject: any = {
                    ResumeId: this.SelectedRequestDetailsList[i].ResumeId,
                    ResumeObject: this.SelectedRequestDetailsList[i],
                    SearchParameters: objSearch
                };
                objSelectedItems.push(_resumeObject);
            }
            sessionStorage.setItem('ResumeCart', JSON.stringify(objSelectedItems));
            if (objSelectedItems.length > 0) {
                alert('Resume(s) has been successfully added to cart.');
            }
        }
        else if (cartItems.length > 0 && this.SelectedRequestDetailsList.length > 0) {
            for (let i = 0; i < this.SelectedRequestDetailsList.length; i++) {
                let _resumeObject: any = {
                    ResumeId: this.SelectedRequestDetailsList[i].ResumeId,
                    ResumeObject: this.SelectedRequestDetailsList[i],
                    SearchParameters: objSearch
                };
                let found = cartItems.some(el => el.ResumeId === _resumeObject.ResumeId);
                if (!found) {
                    cartItems.push(_resumeObject);
                }
                else {
                    let _cartIndex = cartItems.findIndex(x => x.ResumeId == _resumeObject.ResumeId);
                    cartItems[_cartIndex] = _resumeObject;
                }
            }
            sessionStorage.setItem('ResumeCart', JSON.stringify(cartItems));
            if (cartItems.length > 0) {
                alert('Resume(s) has been successfully added to cart.');
            }
        }
    };
    GetSearchObject() {
        let objSearch: any = { loginEmpGPN: '', EngSMU: '', EngType: '', EngSubType: '', MarketSegment: '', EngSector: '', EngSubSector: '', GeographicType: '', Designation: '', YearOfExp: '', TextSearch: this.SearchText };
        if (this.SelectedSMUList.length > 0) {
            objSearch.EngSMU = this.SelectedSMUList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedEngTypeList.length > 0) {
            objSearch.EngType = this.SelectedEngTypeList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedEngSubTypeList.length > 0) {
            objSearch.EngSubType = this.SelectedEngSubTypeList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedMarketSegmentList.length > 0) {
            objSearch.MarketSegment = this.SelectedMarketSegmentList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedEngSectorList.length > 0) {
            objSearch.EngSector = this.SelectedEngSectorList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedEngSubSectorList.length > 0) {
            objSearch.EngSubSector = this.SelectedEngSubSectorList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedGeographicTypeList.length > 0) {
            objSearch.GeographicType = this.SelectedGeographicTypeList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedDesignationsList.length > 0) {
            objSearch.Designation = this.SelectedDesignationsList.map((item) => { return item.Value }).join(',');
        }
        if (this.SelectedYearOfExperience.length > 0) {
            objSearch.YearOfExp = this.SelectedYearOfExperience.map((item) => { return item.Value }).join(',');
        }
        return objSearch;
    };
    StoreDataInCache() {
        let objForSearch: any = { callbackUrl: 'home/SearchResume', objSearchParams: null };
        let objSearchParams: any = {
            RequestDetailsList: this.RequestDetailsList,
            SearchText: this.SearchText,
            SelectedSMUList: this.SelectedSMUList,
            SelectedEngTypeList: this.SelectedEngTypeList,
            SelectedEngSubTypeList: this.SelectedEngSubTypeList,
            SelectedMarketSegmentList: this.SelectedMarketSegmentList,
            SelectedEngSectorList: this.SelectedEngSectorList,
            SelectedEngSubSectorList: this.SelectedEngSubSectorList,
            SelectedGeographicTypeList: this.SelectedGeographicTypeList,
            SelectedDesignationsList: this.SelectedDesignationsList,
            SelectedYearOfExperience: this.SelectedYearOfExperience
        };
        objForSearch.objSearchParams = objSearchParams;
        sessionStorage.setItem('callbackObject', JSON.stringify(objForSearch));
    }
    BindDataFromCache() {
        if (sessionStorage.getItem('callbackObject') != null) {
            this.loading = true;
            let objForSearch: any = null;
            objForSearch = JSON.parse(sessionStorage.getItem('callbackObject'));
            if (objForSearch != null && objForSearch.objSearchParams != null) {
                this.RequestDetailsList = objForSearch.objSearchParams.RequestDetailsList;
                this.SearchText = objForSearch.objSearchParams.SearchText;
                this.SelectedSMUList = objForSearch.objSearchParams.SelectedSMUList;
                this.SelectedEngTypeList = objForSearch.objSearchParams.SelectedEngTypeList;
                this.SelectedEngSubTypeList = objForSearch.objSearchParams.SelectedEngSubTypeList;
                this.SelectedMarketSegmentList = objForSearch.objSearchParams.SelectedMarketSegmentList;
                this.SelectedEngSectorList = objForSearch.objSearchParams.SelectedEngSectorList;
                this.SelectedEngSubSectorList = objForSearch.objSearchParams.SelectedEngSubSectorList;
                this.SelectedGeographicTypeList = objForSearch.objSearchParams.SelectedGeographicTypeList;
                this.SelectedDesignationsList = objForSearch.objSearchParams.SelectedDesignationsList;
                this.SelectedYearOfExperience = objForSearch.objSearchParams.SelectedYearOfExperience;
                sessionStorage.removeItem('callbackObject');
                //if (this.RequestDetailsList.length > 0) {
                //    this.IsFilterTabSelected = true;
                //}
            }
            this.loading = false;
        }
    }
}
